<template>
	<div class="toWaitBox">
		<div class="box">
			<img :src="routeState == 3 ? towaitImg : tofailImg" alt="">
			<p v-if="routeState == 3">你的分销请求正在审核中，如有疑问，请联系分管的审核机构</p>
			<p v-else>你的分销请求没有通过，如有疑问，请联系分管的审核机构</p>
			<el-button @click='toPath' class='btn' type="primary">再次申请开通</el-button>
		</div>
		
	</div>
</template>

<script>
	import { resetApproving } from '@/axios/api.js'
	export default{
		data(){
			return {
				towaitImg:require('./img/towait.png'),
				tofailImg:require('./img/tofail.png'),
				routeState:0
			}
		},
		mounted(){
			this.routeState=this.$route.query.state
		},
		methods: {
			toPath() {
				resetApproving({id:this.$route.query.channelId})
				.then(res => {
					console.log(res);
					if(res.data.code == 0){
						this.$message.success('申请已提交，请您耐心等候')
					}
				})
				.catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style scoped="scoped">
	.toWaitBox{height: calc( 100vh - 306px );position: relative;}
	.box{height: 300px;width: 600px;top: 50%;left: 50%;margin-left: -300px;position: absolute;margin-top: -150px;text-align:center;}
	.btn{margin-top: 30px;}
</style>



// WEBPACK FOOTER //
// src/views/home/towait.vue